import * as Api from './service'
export default {
  namespace: 'serviceScoreRules',
  state: {
    cityPointRule: {}
  },
  effects: {
    * queryCityPointRule ({ payload }, { call, put }) {
      const {
        data: { data }
      } = yield call(Api.queryCityPointRule, payload)
      yield put({
        type: 'save',
        payload: {
          cityPointRule: data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
